module.exports = __webpack_public_path__ + "img/google17.61e354df.jpg";